import { createSlice, PayloadAction } from '@reduxjs/toolkit'

declare global {
  interface Window {
    appData?: AppDataState
  }
}

export interface AppDataState {
  subscriptions: any[]
  campaigns: any[]
  powerPlans: any[]
  extraServices: any[]
  familyExtraServices: any[]
  familyDataPackages: any[]
  [key: string]: any
}

const initialState: AppDataState = {
  subscriptions: [],
  campaigns: [],
  powerPlans: [],
  extraServices: [],
  familyExtraServices: [],
  familyDataPackages: [],
}

const appDataSlice = createSlice({
  name: 'appData',
  initialState,
  reducers: {
    setAppData: (state, action: PayloadAction<Partial<AppDataState>>) => {
      const newAppData = { ...state, ...action.payload }
      window.appData = newAppData
      return newAppData
    },
  },
})

export const { setAppData } = appDataSlice.actions
export default appDataSlice.reducer